import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
    fetchFollowerUserRequest,
    fetchSubscriberListRequest,
    fetchUserProfileRequest,
    searchUserRequest,
} from "../../store/user/user.actions";
import ProfileFollower from "./profile_follower";
import ProfileFollowing from "./profile_following";
import ProfileSubscriber from "./profile_subscriber";

export default function ProfileList() {
    const scrollRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [mode, setMode] = useState("follower");
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchUserProfileRequest());
        if (location.hash === "#follower") {
            setMode("follower");
        } else if (location.hash === "#following") {
            setMode("following");
        } else if (location.hash === "#subscriber") {
            setMode("subscriber");
        } else {
            setMode("follower");
        }
    }, [location]);

    useEffect(() => {
        if (mode === "follower") {
            dispatch(fetchFollowerUserRequest());
        } else if (mode === "following") {
            dispatch(searchUserRequest());
        } else {
            dispatch(fetchSubscriberListRequest());
        }
    }, [mode]);

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="">
                <div className="mb-3">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        {mode}
                    </h2>
                    <p className="text-md font-medium text-black-60">
                        Discover a list of followers, followings , subscribers
                    </p>
                </div>

                <div className="p-4 pb-0 bg-white rounded-lg rounded-br-none rounded-bl-none border border-b-0 border-black-10">
                    <ul
                        onWheel={(e) => scrollH(e)}
                        ref={scrollRef}
                        className="flex items-center pb-[6px] border-b border-black-10 overflow-x-auto no-scrollbar"
                    >
                        <li>
                            <NavLink
                                to={"/page/profile/list#follower"}
                                className={`text-md font-medium ${
                                    mode === "follower"
                                        ? "text-orange-color border-b-2  border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Followers
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={"/page/profile/list#following"}
                                className={`text-md font-medium ${
                                    mode === "following"
                                        ? "text-orange-color border-b-2  border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Following
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={"/page/profile/list#subscriber"}
                                className={`text-md font-medium ${
                                    mode === "subscriber"
                                        ? "text-orange-color border-b-2  border-orange-color pb-[7px]"
                                        : "text-black-60"
                                } hover:pb-[7px] px-6 hover:border-b-2 capitalize  whitespace-nowrap`}
                            >
                                Subscribers
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="flex-grow overflow-y-auto p-4 bg-white rounded-lg rounded-tr-none rounded-tl-none border border-t-0 border-black-10">
                {mode === "follower" ? (
                    <ProfileFollower />
                ) : mode === "following" ? (
                    <ProfileFollowing />
                ) : (
                    <ProfileSubscriber />
                )}
            </div>
        </div>
    );
}
